
const appConfig = {
  APP_VERSION_NUMBER: '1.4.7',
  APP_API_STAGE: "prod", // used in func.js to determine the API stage
  BUILD_DATE: '26-10-2026',
  ENABLE_BETA_FEATURES: false,
  API_TIMEOUT: 10000, // in ms (not used)
};

export default appConfig;


export const clientVersion = appConfig.APP_VERSION_NUMBER;
